/// <reference types="matrixrequirements-type-declarations" />;
import { IItem, app, matrixSession, matrixApplicationUI, globalMatrix } from "../../../globals";
import { FieldHandlerFactory, IItemWatched, MR1 } from "../../businesslogic/index";

import { UIToolsConstants } from "../../matrixlib/MatrixLibInterfaces";
import { LabelTools } from "../../matrixlib/index";
import { IBaseControlOptions, BaseControl } from "./BaseControl";
import { MarkAsTemplateImpl } from "./markAsTemplate";
import { ml } from "./../../matrixlib";
import { refLinkStyle, refLinkTooltip } from "../Parts/RefLinkDefines";
import { HistoryTools } from "../Tools/ItemHistoryView";
import { ReferenceTools } from "../Tools/ItemReferenceView";
import { mTM } from "../../businesslogic/index";
import { mDHF } from "../../businesslogic/index";
import { pluginHooks, plugins } from "../../businesslogic/index";
import { IPanel } from "../Application";
import { EImportMode } from "../../businesslogic/ComponentImport";
import { FieldDescriptions } from "../../businesslogic/FieldDescriptions";
import { EmptyFieldHandler } from "../../businesslogic/FieldHandlers/EmptyFieldHandler";
import { NavigationPanel } from "../MainTree/MainTree";
import { ControlState } from "../../../types";

export type { ITitleToolbarOptions };
export { TitleToolbarImpl };

interface ITitleToolbarOptions extends IBaseControlOptions {
    parameter?: {
        readonly?: boolean; // can be set to overwrite the default readonly status
        placeholder?: string;
    };
    id?: string;
    title?: string;
    item?: IItem;
    canEditTitle?: boolean;
    canDelete?: boolean;
    locked?: string; // set to name of label, if item sis locked by used of label
    unlockers?: string; //  hint who can unlock it
    type?: string;
    validate?: boolean;
    noAutoActivation?: boolean;
}

// TODO: MATRIX-7555: lint errors should be fixed for next line
// eslint-disable-next-line
$.fn.titleToolbar = function (this: JQuery, options: ITitleToolbarOptions) {
    if (!options.fieldHandler) {
        options.fieldHandler = FieldHandlerFactory.CreateHandler(
            globalMatrix.ItemConfig,
            FieldDescriptions.Field_dummy,
            options,
        );
        options.fieldHandler.initData(JSON.stringify(options.fieldValue));
    }
    let baseControl = new TitleToolbarImpl(this, options.fieldHandler as EmptyFieldHandler);
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    this.getController = () => {
        return baseControl;
    };

    baseControl.init(options);
    return this;
};

class TitleToolbarImpl extends BaseControl<EmptyFieldHandler> {
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private settings: ITitleToolbarOptions;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private isInHiddenMode: boolean;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private link: JQuery;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private warnedAboutOutOfDate: boolean;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private _refDlgIcon: JQuery;

    constructor(control: JQuery, fieldHandler: EmptyFieldHandler) {
        super(control, fieldHandler);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    init(options: ITitleToolbarOptions) {
        let that = this;

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        this._refDlgIcon = null;
        let defaultOptions: ITitleToolbarOptions = {
            id: "", // identifier of item for which this control is shown
            title: "",
            controlState: ControlState.FormView, // read only rendering
            dummyData: false, // fill control with a dummy text (for form design...)
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            valueChanged: function () {}, // callback to call if value changes
            canEdit: false, // whether data can be edited
            canEditTitle: false, // whether data can be edited (sometimes the item might 'wrongly marked as' readonly because it is a signed doc with signatures)
            canDelete: false, // whether item can be deleted
            validate: true, // default is true. validation requires non-empty string
            parameter: {
                readonly: false, // can be set to overwrite the default readonly status
                placeholder: "enter title",
            },
        };
        this.isInHiddenMode = false;
        this.settings = <ITitleToolbarOptions>ml.JSON.mergeOptions(defaultOptions, options);

        this.warnedAboutOutOfDate = false;

        let showTools =
            this.settings.controlState === ControlState.FormEdit ||
            this.settings.controlState === ControlState.FormView;

        let title = this.settings.title;
        if (this.settings.controlState === ControlState.DialogCreate) {
            this._root.append(
                $("<span class='pull-left baseControlHelp itemTitleDemand'>" + this.settings.help + "</span>"),
            );
        }

        this._root.data("original", this.settings.title);
        this._root.data("new", this.settings.title);
        // create title bar
        if (showTools) {
            this._root.addClass("itemTitleBar");
        } else if (this.settings.canEdit) {
            this._root.addClass("itemTitleBarNoTools");
        } else {
            this._root.addClass("itemTitleBarNoToolsNoEdit");
        }

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let importSource = matrixSession.isConfigClient() ? null : app.getImportSource(this.settings.item);

        this.link = $("<div>").refLink({
            folder: false, // show id if it exists
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            placeholder: this.settings.parameter.placeholder,
            id: this.settings.id,
            title: title,
            style: this.settings.canEdit && this.settings.canEditTitle ? refLinkStyle.edit : refLinkStyle.link,
            tooltip: refLinkTooltip.none,
            callback: function (id: string, newText: string) {
                if (!that.isInHiddenMode) {
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    if (that.settings.type == "DOC" && newText.indexOf("\\") != -1) {
                        ml.UI.showError("Invalid character in DOC title", "backslashes are not allowed!");
                    }
                    that._root.data("new", newText);
                    if (that.settings.valueChanged) {
                        that.settings.valueChanged.apply(null);
                    }
                }
            },
            validate: this.settings.validate,
            includeSourceLink:
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                !showTools && importSource && importSource.relation == EImportMode.Include
                    ? `included from${importSource.downItem.projectShort}/${importSource.downItem.itemRefWithVersion}`
                    : "",
        });

        $(".refId", this.link).click(function () {
            if (
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                that.settings.controlState != ControlState.FormEdit &&
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                that.settings.controlState != ControlState.FormView
            ) {
                // nothing to show
                return;
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            } else if (ml.Item.parseRef(that.settings.id).isFolder) {
                return;
            } else {
                let currentPanel: IPanel = matrixApplicationUI.currentPanel;
                if (currentPanel.toggleZen) {
                    currentPanel.toggleZen();
                }
            }
        });

        this.showOutOfDateIcon();

        this.link.addClass("itemTitle rowFlex");
        if (this.settings.locked) {
            let labelTools = ml.CreateNewLabelTools();
            let dn = labelTools.getDisplayName(this.settings.locked);
            let lockedBy = $("<span class='lockedItem'>").html("<i class='fa fa-lock-alt'></i> (locked)");

            // tooltip with info why it is locked and how it can be unlocked
            $(".refId", this.link).append(lockedBy);

            let tooltip = "Locked by label '" + this.settings.locked + (dn ? ": " + dn : "") + "'";
            tooltip += this.settings.unlockers
                ? ". Can be unlocked by: " + this.settings.unlockers + "."
                : ". Cannot be unlocked in UI.";

            lockedBy.tooltip({ title: tooltip, placement: "bottom" });
        }
        this._root.append(this.link);
        if (this.settings.controlState === ControlState.DialogCreate && !this.settings.noAutoActivation) {
            setTimeout(function () {
                $(".refTitle", that.link).click();
            }, 500);
        }

        if (this.settings.controlState !== ControlState.DialogCreate) {
            this.link.find(".refId").append($("<div class='pull-right itemViewers'>"));
        }
        $(this._root).on("focusout.editable", function (e) {
            $(".editable-open").parent().find("form").trigger("submit");
            console.log("title submitted");
        });

        if (showTools) {
            // add titlebar tools
            let itemTools = $("<div class=' hidden-print toolsBarButtonsContainer'></div>");
            this._root.append(itemTools);

            let miTouch = $(
                '<li title="Create new version of item"><a href="javascript:void(0)" id="toolTouch">Touch</a></li>',
            ).click(function () {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                app.touchAsync(that.settings.id, 1);
            });

            let bShare = $(
                '<div class="btn-group">' +
                    ' <button id="shareButton"  tabindex="-1" type="button" title data-original-title="Tools" data-toggle="dropdown" class="btn btn-item btn-sm dropdown-toggle">' +
                    '<span class="fal fa-ellipsis-v-alt"></span></button>' +
                    ' <ul class="sharemenu dropdown-menu dropdown-menu-sub pull-right" role="menu">' +
                    " </ul>" +
                    "</div>",
            );
            let bShareMenu = $("ul", bShare);

            let extras = globalMatrix.ItemConfig.getExtrasConfig();

            if (
                !this.settings.locked &&
                !this.settings.isFolder &&
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                app.touchToolAvailable(this.settings.item) &&
                (!extras || !ml.JSON.isTrue(extras.noTouch))
            ) {
                bShareMenu.append(miTouch);
            }

            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            if (!mDHF.isDocumentType(this.settings.type)) {
                if (matrixSession.getUISettings().legacyPrint) {
                    let miPrint = $('<li title="prepare to print"><a href="javascript:void(0)">Print</a></li>').click(
                        function () {
                            app.print();
                        },
                    );
                    bShareMenu.append(miPrint);
                }
            }

            if (app.mailToolAvailable()) {
                const miMail = $(
                    '<li class="mailMenu"><a id="toolSendTo" href="javascript:void(0)">Send link by mail</a></li>',
                );

                miMail.click(function (event: JQueryEventObject) {
                    let itemId = app.getCurrentItemId();
                    let message = ml.Mail.getCannedMessage("link", "", itemId);

                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    ml.Mail.sendMailDlg("", null, itemId, message, "");
                });
                bShareMenu.append(miMail);
            } else {
                const miMail = $(
                    '<li class="mailMenu"><a href="mailto:?subject=' +
                        this.settings.id +
                        "&amp;body=" +
                        location +
                        '">Email</a></li>',
                );
                bShareMenu.append(miMail);
            }

            let labelTools = $('<div class="labelTools">');

            if (globalMatrix.ItemConfig.getLabelsConfig()?.useLabelBar) {
                let labelBar = $("<div class='labelBar'>");
                this._root.after(labelBar);
                labelBar.append(labelTools);
            } else {
                itemTools.after(labelTools);
            }

            let workflowTools = $('<div class="btn-group workflowTools">');
            itemTools.append(workflowTools);

            if (
                !this.settings.isFolder &&
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                (app.hasLinks(this.settings.item) ||
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    (mTM.getCloneSources() && mTM.getCloneSources().indexOf(this.settings.type) != -1))
            ) {
                this._refDlgIcon = $(`<i class="fal fa-sitemap" aria-hidden="true" />`);
                let refDlgButton = $(
                    "<button id='referenceToolBtn' tabindex='-1' title data-original-title='References' class='btn btn-item'>",
                ).append(this._refDlgIcon);
                let refDlgGroup = $("<div class='btn-group'>")
                    .append(refDlgButton)
                    .click(function () {
                        let rt = new ReferenceTools();

                        if (that.settings.item) {
                            rt.showReferenceDialog({
                                item: that.settings.item,
                                canEdit: that.settings.canEdit || that.settings.allowlinkedit,
                            });
                        }
                    });
                itemTools.append(refDlgGroup);
                this.updateItem();
            }

            if (!this.settings.isFolder) {
                // there is no easy way to get history of folder
                let historyTools = new HistoryTools();
                historyTools.renderButtons({
                    control: itemTools,
                    id: this.settings.id,
                    isFolder: this.settings.isFolder,
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    item: this.settings.item,
                    readOnly: !this.settings.canEdit,
                });

                if (importSource) {
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    const startText = importSource.relation == EImportMode.Include ? "included from " : "copied from ";
                    let sourceInfo =
                        startText + importSource.downItem.projectShort + "/" + importSource.downItem.itemRefWithVersion;
                    let sourceLink = $(
                        `<div  class='btn-group'><button id='originalItemBtn' tabindex='-1' title data-original-title='${sourceInfo}' class='btn btn-item'> <span class='fal fa-external-link-alt'></span></button></div>`,
                    );

                    sourceLink.click(() =>
                        window.open(
                            globalMatrix.matrixBaseUrl +
                                "/" +
                                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                                importSource.downItem.projectShort +
                                "/" +
                                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                                importSource.downItem.itemRefWithVersion.split("-v")[0],
                        ),
                    );

                    itemTools.append(sourceLink);
                }

                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                let usedBy = app.getUsedBy(this.settings.item);

                if (usedBy) {
                    let linkList = $("<ul>");

                    for (let useByLink of usedBy) {
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        let targetType = useByLink.relation == EImportMode.Include ? "included as" : "copied as";
                        let targetInfo = useByLink.upItem.projectShort + "/" + useByLink.upItem.itemRefWithVersion;
                        $(
                            `<li>${targetType} <span data-target='${
                                targetInfo.split("-v")[0]
                            }' class='refIdHyper includedLink'>${targetInfo}</span></li>`,
                        ).appendTo(linkList);
                    }
                    let targetLink = $(
                        `<div  class='btn-group'><button id='originalItemBtn' tabindex='-1' title data-original-title='used by' class='btn btn-item'> <span class='fal fa-external-link-square-alt'></span></button></div>`,
                    );
                    itemTools.append(targetLink);
                    targetLink.click(() => {
                        let usedByDlg = $("<div>").appendTo($("body"));

                        ml.UI.showDialog(
                            usedByDlg,
                            "Item used by",
                            linkList,
                            300,
                            200,
                            [
                                {
                                    text: "Close",
                                    class: "btnDoIt",
                                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                                    // eslint-disable-next-line
                                    click: function () {
                                        usedByDlg.dialog("close");
                                    },
                                },
                            ],
                            UIToolsConstants.Scroll.Vertical,
                            true,
                            true,
                            () => {
                                usedByDlg.remove();
                            },
                            () => {
                                $(".includedLink", linkList).click((e: JQueryEventObject) => {
                                    window.open(globalMatrix.matrixBaseUrl + "/" + $(e.delegateTarget).data("target"));
                                });
                            },
                            () => {},
                        );
                    });
                }
            }

            // The TestManager customizes folder menus in some cases.
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            mTM.UpdateFolderMenu(bShareMenu, this.settings.item);

            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            let itemParsed = ml.Item.parseRef(this.settings.item.id);
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let root = itemParsed.number == 1 && itemParsed.isFolder;

            if (this.settings.canEdit && this.settings.item && app.canDeleteItem(this.settings.item) && !root) {
                let bDelete = $('<li class="deleteMenu">Delete</li>');

                bShareMenu.prepend("<li class='divider'></li>");
                bShareMenu.prepend(bDelete);

                bDelete.click(function () {
                    if (!that.settings.item) {
                        return;
                    }

                    let whatToDelete = that.settings.id;
                    MR1.triggerBeforeDeleteAsync(that.settings.item)
                        .done(function () {
                            if (!that.settings.item) {
                                return;
                            }

                            let isTemplate = that.settings.item.id && mDHF.isUsedAsTemplate(that.settings.item.id);
                            let message = isTemplate
                                ? that.settings.item.id +
                                  " is used as template. Deleting will also remove the templates!"
                                : "Delete '" + that.settings.item.id + " " + title + " '?";
                            let ok = isTemplate ? "Delete and remove templates" : "Delete";

                            ml.UI.showConfirm(
                                1,
                                { title: message, ok: ok },
                                function () {
                                    if (!whatToDelete) {
                                        return;
                                    }

                                    let deletedItems = app.getChildrenIdsRec(whatToDelete);
                                    app.deleteItem(whatToDelete).done(function () {
                                        if (!that.settings.item) {
                                            return;
                                        }

                                        MarkAsTemplateImpl.removeFromTemplates(deletedItems);
                                        MR1.triggerAfterDelete(that.settings.item);
                                        if (isTemplate && that.settings.item.id) {
                                            mDHF.removeAsTemplate(that.settings.item.id);
                                        }

                                        NavigationPanel.focusTree();
                                    });
                                },
                                function () {
                                    NavigationPanel.focusTree();
                                },
                            );
                        })
                        .fail(function () {
                            ml.Logger.log("warn", "delete cancelled using MR1");
                        });
                });
            }
            itemTools.append(bShare);
            itemTools.append(ml.ContextFrames.getExpender());
            $("button", itemTools).tooltip({ placement: "bottom" });

            // moved after adding history (for jobs plugin to be able to remove it;-)
            plugins.updateMenu(pluginHooks.shares, bShareMenu);
        }
    }
    // public interface
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async hasChangedAsync() {
        return this._root.data("original") !== this._root.data("new");
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async getValueAsync() {
        return this._root.data("new");
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setValue(newTitle: string, fireUpdate: boolean) {
        this._root.data("new", newTitle);
        this._root.find("input").val(newTitle);
        this._root.find(".refTitle").html(newTitle);

        if (fireUpdate && this.settings.valueChanged) {
            this.settings.valueChanged.apply(null);
        }
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getText() {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getValueRaw() {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    titleCreationMode() {
        // special mode where control is hidden and used by report generator to set the value
        this._root.hide();
        this.isInHiddenMode = true;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    destroy() {
        if (this.link) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<XEditable>(<any>this.link)).destroy();
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    resizeItem() {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setViewers(viewers: IItemWatched) {
        let that = this;

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        if (viewers.item !== this.settings.item.id) {
            // that can happen
            // e.g. if use changes item and does not type for a while, the old item will be pinged
            return;
        }
        $(".itemViewers", this._root).html("");
        let ignoredFirstMe = false;
        let otherEditor = viewers.editor && !viewers.editor.thisSocket ? viewers.editor.user : "";

        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (viewers.editor && this.settings.type != "XTC" && this.settings.type != "SIGN") {
            $("#thisItemIsDated").hide();
        } else {
            $("#thisItemIsDated").show();
        }

        $.each(viewers.users, function (vidx, viewer) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (viewer == matrixSession.getUser() && !ignoredFirstMe) {
                // I myself appear at most once in an item
                ignoredFirstMe = true;
                return;
            }

            let user = globalMatrix.ItemConfig.getUserInfo(viewer);
            if (!user) {
                // that's a spying super user;-)
                return;
            }
            let name = (user.firstName ? user.firstName : "") + " " + (user.lastName ? user.lastName : "");
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (name == " ") {
                name = viewer;
            }
            let itemAccess = "itemViewer";
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (otherEditor == viewer) {
                otherEditor = ""; // there can only be one
                itemAccess = "itemEditor";
                name += " - is editing this item";
            }
            let spanItemViewer = $("<div class='" + itemAccess + "' title='" + name + "'></div>");
            spanItemViewer.append(ml.UI.getAvatar(user.login, 32));

            $(".itemViewers", that._root).append(spanItemViewer);
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    updateItem(newItem?: IItem) {
        let that = this;
        if (newItem) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            if (newItem.id !== this.settings.item.id) {
                // that can happen
                // e.g. if use changes item and does not type for a while, the old item will be pinged
                // console.write("newItem.id !== settings.item.id");
                return;
            }
            if (
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                newItem.history.length &&
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                newItem.history.length !== this.settings.item.history.length &&
                !(
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // prettier-ignore
                    (newItem.history.length === this.settings.item.history.length + 1 &&
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        newItem.history[0].action === "move" &&
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        newItem.history[0].user === matrixSession.getUser())
                ) // no warning after simple move by this user! MATRIX-1416
            ) {
                if (!this.warnedAboutOutOfDate) {
                    let message =
                        "User " +
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        newItem.history[0].user +
                        " changed item after you loaded it <br><br> Last change at " +
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        newItem.history[0].dateUserFormat;

                    ml.UI.showConfirm(
                        -12,
                        { title: message, ok: "Update to new", nok: "Keep displaying old" },
                        function () {
                            app.cancel();
                        },
                        function () {
                            that.warnedAboutOutOfDate = true;
                            that._root.addClass("staleItem");
                            $(".itemTitle", that._root).tooltip({
                                title: message + " ",
                                placement: "right",
                                html: true,
                                template:
                                    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner" style="max-width:800px"></div></div>',
                            });
                        },
                    );
                }
            }
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            this.settings.item.downLinks = newItem.downLinks;
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            this.settings.item.upLinks = newItem.upLinks;
        }

        if (this._refDlgIcon) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            let downMissing = app.isDownLinkMissing(this.settings.item);
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            let upMissing = app.isUpLinkMissing(this.settings.item);
            this._refDlgIcon.removeClass("refGood").removeClass("refOutdated").removeClass("refMissing");
            if (upMissing || downMissing) {
                this._refDlgIcon.addClass("refMissing");
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            } else if (app.isAnyLinkOutdated(this.settings.item)) {
                this._refDlgIcon.addClass("refOutdated");
            } else {
                this._refDlgIcon.addClass("refGood");
            }
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private toggleOutOfDateIcon() {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private showOutOfDateIcon() {
        let that = this;

        if (
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            this.settings.controlState == ControlState.FormEdit &&
            this.settings.item &&
            this.settings.item.history &&
            this.settings.item.upLinks &&
            this.settings.item.upLinks.length
        ) {
            // check if item is potentially out of date
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let isXTCorSIGN = this.settings.type == "XTC" || this.settings.type == "SIGN";
            // for XTC take time of creation of XTC, for other the last modification time
            let thisTime = this.settings.item.history[isXTCorSIGN ? this.settings.item.history.length - 1 : 0].date;
            // get the last modification date of all parents
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            let parentLastChange = new Date(this.settings.item.upLinks[0].modDate);
            for (let parent of this.settings.item.upLinks) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                if (new Date(parent.modDate) > parentLastChange) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    parentLastChange = new Date(parent.modDate);
                }
            }
            if (new Date(thisTime) < parentLastChange) {
                let clickToTouch = this.settings.canEdit ? " Click to touch" : "";
                let message = isXTCorSIGN
                    ? "the underlying " +
                      // TODO: MATRIX-7555: lint errors should be fixed for next line
                      // eslint-disable-next-line
                      (this.settings.type == "XTC" ? "test" : "DOC") +
                      " was changed after the " +
                      this.settings.type +
                      " was created"
                    : "at least one uplinked item is newer than this item." + clickToTouch;
                let icon = $(`<span id="thisItemIsDated" class="fal fa-history datedLink" title="${message}"></span>`);
                if (this.settings.canEdit && !isXTCorSIGN) {
                    icon.css("cursor", "pointer").click(() => {
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        app.touchAsync(that.settings.id, 1);
                    });
                }
                this.link.find(".refId").append(icon);
            }
        }
    }
}
